// Keep the originating client Studio separate from the seller (which may be a Brand).
// Build internal destinations only; no arbitrary return URL is accepted.
export function shopContext(params, fallbackSlug='', restored={}) {
  return {brand: params.get('brand') || restored.brand || '', studio: params.get('studio') || restored.studio || fallbackSlug, studioId: params.get('studio_id') || restored.studioId || '', store: params.get('store') || restored.store || ''};
}
export function clientAppHref(studio) {
  return studio ? '/client?' + new URLSearchParams({studio,view:'home'}) : '/client';
}
export function shopHref(seller, context={}) {
  const params=new URLSearchParams();
  if(context.brand)params.set('brand',context.brand);
  if(context.studio)params.set('studio',context.studio);
  if(context.studioId)params.set('studio_id',context.studioId);
  if(!seller&&context.store)params.set('store',context.store);
  const search=params.toString();
  return '/shop'+(seller?'/'+encodeURIComponent(seller):'')+(search?'?'+search:'');
}
// Checkout returns without the query context. Restore only this account/order,
// never the last globally visited Studio or another account's origin.
export function rememberOrderOrigin(owner,order,context) {
  if(!owner||!order||(!context.studio&&!context.brand))return;
  try{sessionStorage.setItem(`tps-shop-origin:${owner}:${order}`,JSON.stringify({at:Date.now(),brand:context.brand,studio:context.studio,studioId:context.studioId,store:context.store}));}catch{}
}
export function readOrderOrigin(owner,order) {
  try{if(!owner||!order)return {};const value=JSON.parse(sessionStorage.getItem(`tps-shop-origin:${owner}:${order}`));if(!value||Date.now()-value.at>86400000)return {};return Object.fromEntries(['studio','studioId','store','brand'].filter(k=>typeof value[k]==='string'&&value[k].length<=200).map(k=>[k,value[k]]));}catch{return {};}
}
